import { render, staticRenderFns } from "./sales-department.vue?vue&type=template&id=15e45d0c&scoped=true&"
import script from "./sales-department.vue?vue&type=script&lang=js&"
export * from "./sales-department.vue?vue&type=script&lang=js&"
import style0 from "./sales.styl?vue&type=style&index=0&id=15e45d0c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e45d0c",
  null
  
)

export default component.exports